import MultiStepProgressBar from '../MultiStepProgressBar';
import React, { useContext, useEffect, useState } from 'react'
import SingleFormScreen from './SingleFormScreen';
import { TOKEN, getCaseDetailsApi } from 'Constants';
import { Context } from 'Context/Context';


function MultiStepCreateForm({id}) {

    const [caseData, setCaseData] = useState({}); 
    const [page, setPage] = useState(0);
    const {makeApiCallFunc} = useContext(Context);

  
    useEffect(() => {
        makeApiCallFunc(
          getCaseDetailsApi+'/'+id,
          null,
          ({data})=>
          {
             window.scrollTo(0,0);
             setCaseData(data);
          },
          function (error) {
            console.log(error);
        }
        )
    },[page])


  return (
    <div className='w-full mb-10'>
        <MultiStepProgressBar page={page} setPage= {setPage} />
        <div className='w-full lg:px-20'>
            <SingleFormScreen 
            page={page} 
            setPage={setPage} 
            caseData={caseData}
            caseId = {id}
            setCaseData={setCaseData}
            />
        </div>
    </div>
    
  )
}

export default MultiStepCreateForm